export const WA_NUMBER_DISPLAY = "+66 83 469 1637";

export const waLink = (message) =>
    `https://wa.me/66834691637${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const WA_MESSAGES = {
    hero: "Hi BookMyVIP, I'd like to book a VIP table. Please share the available options.",
    concierge: "Hi BookMyVIP, I need help planning my nightlife experience.",
    booking:
        "Hi BookMyVIP, I'd like to make a VIP booking. My destination is __, date is __, and we are __ people.",
    plan: "Hi BookMyVIP, I'd like help planning my VIP night out.",
    destination: (city) =>
        `Hi BookMyVIP, I'm looking for a VIP table in ${city}.`,
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) {
        window.location.href = `/#${id}`;
        return;
    }
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1595751866756-3ea5aa405812?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBuaWdodGNsdWIlMjBWSVAlMjB0YWJsZSUyMGNoYW1wYWduZXxlbnwwfHx8fDE3ODc0MTM0NTh8MA&ixlib=rb-4.1.0&q=85&w=2400&auto=format&fit=crop",
    bangkok:
        "https://images.unsplash.com/photo-1731239027673-1a5c6cd61380?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxiYW5na29rJTIwbmlnaHQlMjBza3lsaW5lfGVufDB8fHx8MTc4NzQxMzQ1OHww&ixlib=rb-4.1.0&q=85&w=1600&auto=format&fit=crop",
    phuket:
        "https://images.unsplash.com/photo-1540541338287-41700207dee6?q=85&w=1600&auto=format&fit=crop",
    pattaya:
        "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=85&w=1600&auto=format&fit=crop",
    kohSamui:
        "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=85&w=1600&auto=format&fit=crop",
    experience:
        "https://images.unsplash.com/photo-1581775120934-9851ea6cf3e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwY2VsZWJyYXRpbmclMjBjaGFtcGFnbmUlMjBuaWdodHxlbnwwfHx8fDE3ODc0MTM0NTh8MA&ixlib=rb-4.1.0&q=85&w=1600&auto=format&fit=crop",
    finalCta:
        "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?q=85&w=2400&auto=format&fit=crop",
};

export const DESTINATIONS = [
    {
        slug: "bangkok",
        city: "Bangkok",
        copy: "Rooftop views. World-class clubs. Non-stop energy.",
        image: IMAGES.bangkok,
    },
    {
        slug: "phuket",
        city: "Phuket",
        copy: "Beach clubs, luxury nightlife and unforgettable nights.",
        image: IMAGES.phuket,
    },
    {
        slug: "pattaya",
        city: "Pattaya",
        copy: "High-energy nightlife and VIP experiences.",
        image: IMAGES.pattaya,
    },
    {
        slug: "koh-samui",
        city: "Koh Samui",
        copy: "Island nights with a luxury twist.",
        image: IMAGES.kohSamui,
    },
];

export const FAQ_ITEMS = [
    {
        q: "What does BookMyVIP do?",
        a: "BookMyVIP helps travelers arrange VIP tables and premium nightlife experiences in major nightlife destinations.",
    },
    {
        q: "Which cities do you cover?",
        a: "We currently focus on Thailand, including Bangkok, Phuket, Pattaya and Koh Samui, with additional destinations planned.",
    },
    {
        q: "How do I make a booking?",
        a: "Simply contact our WhatsApp concierge with your destination, date and group size.",
    },
    {
        q: "Can I choose the club?",
        a: "Yes. Tell us your preferred club or the type of nightlife experience you're looking for and we'll help with available options.",
    },
    {
        q: "Can I book before arriving in Thailand?",
        a: "Yes. Advance booking is recommended, particularly for weekends, holidays and high-demand venues.",
    },
    {
        q: "Do you offer bottle-service packages?",
        a: "Where available, we can help arrange VIP tables and bottle-service packages.",
    },
    {
        q: "Can you help if I don't know which club to choose?",
        a: "Absolutely. Tell us your preferred vibe, budget, location and group size and our concierge can suggest suitable options.",
    },
    {
        q: "Is payment made directly through BookMyVIP?",
        a: "Your concierge will explain the available booking and payment process for your selected experience.",
    },
];
